import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Alliance, GovernyInfo, NewsData } from "../../../../lib/types";

import { portraits } from "../../../../assets/images/races";
import NewsPersonSpell from "./NewsPersonSpell";
import { NEWS_DETAIL, systemClass } from "../../../../lib/enums";
import { setSameHeight } from "../../../../lib/elementUtilities";
import { DragescentState } from "../../../../store/reducers/stateType";
import NewsPersonThievesAction from "./NewsPersonThievesAction";
import NewsPersonBattleRound from "./NewsPersonBattleRound";
import NewsPersonBanner from "./NewsPersonBanner";
import NewsPersonSummary from "./NewsPersonSummary";

interface INewsContentProps {
  news: any;
  coalition: Alliance;
  battleground?: { [key: string]: NewsData[] };
}

const NewsContent = ({
  news,
  coalition,
  battleground
}: INewsContentProps) => {
  const counterintelligenceDiv = useRef<HTMLDivElement>(null);
  const crimesDiv = useRef<HTMLDivElement>(null);
  const opponentSpellsDiv = useRef<HTMLDivElement>(null);
  const buffsDiv = useRef<HTMLDivElement>(null);
  const debuffsDiv = useRef<HTMLDivElement>(null);
  const damagesDiv = useRef<HTMLDivElement>(null);
  // const rangeDiv = useRef<HTMLDivElement>(null);
  // const armyLosesDiv = useRef<HTMLDivElement>(null);
  // const siegeDiv = useRef<HTMLDivElement>(null);
  const allySummaryDiv = useRef<HTMLDivElement>(null);
  const opponentSummaryDiv = useRef<HTMLDivElement>(null);

  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const unitNames = useSelector((state: DragescentState) => state.governorate.unitNames);
  const war = useSelector((state: DragescentState) => state.governorate.war);
  const opponent = useSelector((state: DragescentState) => state.governorate.opponent);

  console.log(battleground);

  useEffect(() => {
    setSameHeight(buffsDiv.current || undefined);
    if (debuffsDiv) {
      setSameHeight(counterintelligenceDiv.current || undefined);
      setSameHeight(crimesDiv.current || undefined);
      setSameHeight(opponentSpellsDiv.current || undefined);
      setSameHeight(debuffsDiv.current || undefined);
      setSameHeight(damagesDiv.current || undefined);
      // setSameHeight(rangeDiv.current || undefined);
      // setSameHeight(armyLosesDiv.current || undefined);
      // setSameHeight(siegeDiv.current || undefined);
      setSameHeight(allySummaryDiv.current || undefined);
      setSameHeight(opponentSummaryDiv.current || undefined);
    }
  }, [news, battleground]);

  return (
    <>
      <h2 className='h2'>
        <span className={"bordered"}>Alliance members</span>
      </h2>
      <span className='divider'/>
      <div className='boxes-group'>
        <div className="box news-item" style={{ overflowX: "scroll" }}>
          <div className="row persons" style={{ overflowX: "unset" }}>
            {coalition.members.map(
              member => <div className="col-sm-3 person-col">
                <div className="person no-hover" style={{ marginTop: 0, marginBottom: 0, minHeight: 0 }}>
                  <img src={portraits[member.race.name]} alt={"Race portrait"} className="photo"/>
                  <p><strong className={`subname ${member.race.name}`}>{member.name}</strong></p>
                </div>
              </div>
            )}
          </div>
          {news && news[3] && news[3][1] && news[3][1].length > 1
          && <div ref={buffsDiv} className="row persons" style={{ overflowX: "unset" }}>
            {coalition.members.map(
              member => <div className="col-sm-3 person-col">
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-kouzlo-poz middle"/>
                    Buffs
                    <i className="icon icon-kouzlo-poz middle"/>
                  </h3>
                  {news[3][1].filter((n: NewsData) => n.governorateB.id === member.id)
                    .map((n: NewsData) => <NewsPersonSpell
                      sender={n.governorate}
                      target={n.governorateB}
                      peace={!war}
                      spell={n}
                    />)
                  }
                </div>
              </div>
            )}
          </div>
          }
          {news && news[4] && news[4][0] && news[4][0].length > 1
          && <div ref={debuffsDiv} className="row persons" style={{ overflowX: "unset" }}>
            {coalition.members.map(
              member => <div className="col-sm-3 person-col">
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-kouzlo-neg middle"/>
                    Debuffs
                    <i className="icon icon-kouzlo-neg middle"/>
                  </h3>
                  {news[4][0].filter((n: NewsData) => n.governorate.id === member.id)
                    .map((n: NewsData) => <NewsPersonSpell
                        sender={n.governorateB}
                        target={n.governorate}
                        unitNames={unitNames}
                        peace={false}
                        spell={n}
                    />)
                  }
                </div>
              </div>
            )}
          </div>
          }
          {news && news[6] && news[6].length > 1
          && <div ref={counterintelligenceDiv} className="row persons" style={{ overflowX: "unset" }}>
            {coalition.members.map(
              member => <div className="col-sm-3 person-col">
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-zlodej-obrana middle"/>
                    Counterintelligencies
                    <i className="icon icon-zlodej-obrana middle"/>
                  </h3>
                  {news[6].filter((n: NewsData) => n.governorate.id === member.id
                    && n.thiefAction.id === 8)
                    .map((n: NewsData) => <NewsPersonThievesAction
                      sender={n.governorateB}
                      target={n.governorate}
                      action={n}
                    />)
                  }

                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-zlodej-obrana middle"/>
                    Crimes
                    <i className="icon icon-zlodej-obrana middle"/>
                  </h3>
                  {news[6].filter((n: NewsData) => n.governorate.id === member.id
                    && n.thiefAction.id !== 8)
                    .map((n: NewsData) => <NewsPersonThievesAction
                      sender={n.governorateB}
                      target={n.governorate}
                      action={n}
                      opponent={false}
                    />)
                  }
                </div>
              </div>
            )}
          </div>
          }
        </div>
        <span className='divider'/>
      </div>

      <h2 className='h2'>
        <span className={"bordered"}>Opponent members</span>
      </h2>
      <span className='divider'/>
      {war && opponent && <div className='boxes-group'>
        <div className="box news-item" style={{ overflowX: "scroll" }}>
          <div className="row persons" style={{ overflowX: "unset" }}>
            {opponent.members.map(
              (member: GovernyInfo) => <div className="col-sm-3 person-col">
                <div className="person no-hover" style={{ marginTop: 0, marginBottom: 0, minHeight: 0 }}>
                  <img src={portraits[member.race.name]} alt={"Race portrait"} className="photo"/>
                  <p><strong className={`subname ${member.race.name}`}>{member.name}</strong></p>
                </div>
              </div>
            )}
          </div>
          {news && news[3] && news[3][0] && news[3][0].length > 1
          && <div ref={opponentSpellsDiv} className="row persons" style={{ overflowX: "unset" }}>
            {opponent.members.map(
              (member: GovernyInfo) => <div className="col-sm-3 person-col">
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-kouzlo-neg middle"/>
                    Debuffs
                    <i className="icon icon-kouzlo-neg middle"/>
                  </h3>
                  {news[3][0].filter((n: NewsData) => n.governorateB.id === member.id)
                    .map((n: NewsData) => <NewsPersonSpell
                        sender={n.governorate}
                        target={n.governorateB}
                        unitNames={unitNames}
                        peace={false}
                        spell={n}
                    />)
                  }
                </div>
              </div>
            )}
          </div>
          }
          {news && news[5] && news[5].length > 1
          && <div ref={crimesDiv} className="row persons" style={{ overflowX: "unset" }}>
            {opponent.members.map(
              (member:GovernyInfo) => <div className="col-sm-3 person-col">
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  <h3 className="h3 padding white text-center spacer-narrow">
                    <i className="icon icon-zlodej-obrana middle"/>
                    Crimes
                    <i className="icon icon-zlodej-obrana middle"/>
                  </h3>
                  {news[5].filter((n: NewsData) => n.governorateB.id === member.id)
                    .map((n: NewsData) => <NewsPersonThievesAction
                      sender={n.governorate}
                      target={n.governorateB}
                      action={n}
                      opponent={true}
                    />)
                  }
                </div>
              </div>
            )}
          </div>
          }
        </div>
        <span className='divider'/>
      </div>}

      {battleground && <>
        <h2 className="h2">
          <span className={"bordered"}>Battleground</span>
        </h2>
        <span className='divider'/>
        <div className='boxes-group'>
          <div className="box news-item" style={{ overflowX: "scroll" }}>
            <div ref={damagesDiv} className="row persons" style={{ overflowX: "unset" }}>
              {["left", "center", "right", "backup"].map(position => <div className="col-sm-3 person-col">
                <NewsPersonBanner
                  ally={true}
                  position={position}
                  virtual={false}
                  stats={(battleground[position][0]?.details[NEWS_DETAIL.BannerInitStats]?.value.split(";")) || undefined}
                />
                <div className={`person no-hover ${systemClass.MatchHeight}`}
                     style={{ marginBottom: 0, marginTop: 0, textAlign: "initial" }}>
                  {battleground[position]?.map(round => <NewsPersonBattleRound round={round} />)}
                </div>
              </div>)}
            </div>
          </div>
        </div>
      </>}

      {battleground && <>
        <h2 className="h2">
              <span className="bordered">
                Results
              </span>
        </h2>
        <span className='divider'/>
        <div className='boxes-group'>
          <div className="box">
            <h2 className="h2">
              <i className="icon icon-armada middle"/>&nbsp;
              {news[11][0].draw
                ? <>The battle is even</>
                : <>The winner of the battle is {news[11][0].success
                  ? alliance.name
                  : (news[11][0]?.coalitionB?.name || "Enemy")}</>}
              &nbsp;<i className="icon icon-armada middle"/>
            </h2>
          </div>
          <span className='divider'/>
          <div className={"box"} style={{ overflowX: "scroll" }}>
            <div className="row persons" style={{ overflowX: "unset" }}>
              {coalition.members.map(
                member => <div className="col-sm-3 person-col">
                  <div className="person no-hover" style={{ marginTop: 0, marginBottom: 0, minHeight: 0 }}>
                    <img src={portraits[member.race.name]} alt={"Race portrait"} className="photo"/>
                    <p><strong className={`subname ${member.race.name}`}>{member.name}</strong></p>
                  </div>
                </div>
              )}
            </div>
            <div ref={allySummaryDiv} className="row persons" style={{ overflowX: "unset" }}>
              {coalition.members.map((member) => {
                const damagedBuildings = [
                  ...((news[4] && news[4][0]) || [])
                    .filter((n: NewsData) => n.governorate.id === member.id
                      && n.details[NEWS_DETAIL.BuildingDamage]),
                  ...(news[6] || [])
                    .filter((n: NewsData) => n.governorate.id === member.id
                      && n.details[NEWS_DETAIL.BuildingDamage])
                ].reduce((db, n) => `${db};${n.details[NEWS_DETAIL.BuildingDamage].value}`, "");
                const mageXP = [
                  ...((news[4] && news[4][0]) || [])
                    .filter((n: NewsData) => n.governorate.id === member.id
                      && n.details[NEWS_DETAIL.GeneralExpGain]),
                  ...((news[3] && news[3][0]) || [])
                    .filter((n: NewsData) => n.governorate.id === member.id
                      && n.details[NEWS_DETAIL.GeneralExpGain])
                ].reduce((xp, n) => xp += Number.parseInt(
                  n.details[NEWS_DETAIL.GeneralExpGain].value,
                  10
                ), 0);
                const thiefXP = [
                  ...(news[5] || []).filter((n: NewsData) => n.governorate.id === member.id
                    && n.details[NEWS_DETAIL.GeneralExpGain]),
                  ...(news[6] || []).filter((n: NewsData) => n.governorate.id === member.id
                    && n.details[NEWS_DETAIL.GeneralExpGain])
                ].reduce((xp, n) => xp += Number.parseInt(
                  n.details[NEWS_DETAIL.GeneralExpGain].value,
                  10
                ), 0);

                return (
                  <div className="col-sm-3 person-col">
                    <div
                      className={`person no-hover ${systemClass.MatchHeight}`}
                      style={{
                        minHeight: "50px",
                        marginTop: "0",
                        marginBottom: "0",
                        textAlign: "initial"
                      }}
                    >
                      <NewsPersonSummary
                        // banner={news[1].}
                        damagedBuildings={damagedBuildings}
                        ally={true}
                        mageXp={mageXP}
                        thiefXp={thiefXP}
                      />
                    </div>
                  </div>)
              })}
            </div>
            <div className="row persons" style={{ overflowX: "unset" }}>
              {opponent.members.map(
                (member: GovernyInfo) => <div className="col-sm-3 person-col">
                  <div className="person no-hover" style={{ marginTop: 0, marginBottom: 0, minHeight: 0 }}>
                    <img src={portraits[member.race.name]} alt={"Race portrait"} className="photo"/>
                    <p><strong className={`subname ${member.race.name}`}>{member.name}</strong></p>
                  </div>
                </div>
              )}
            </div>
            <div ref={opponentSummaryDiv} className="row persons" style={{ overflowX: "unset" }}>
              {opponent.members.map((member: GovernyInfo) => {
                const damagedBuildings = [
                  ...((news[3] && news[3][0]) || [])
                    .filter((n: NewsData) => n.governorateB.id === member.id
                      && n.details[NEWS_DETAIL.BuildingDamage]),
                  ...(news[5] || []).filter((n: NewsData) => n.governorateB.id === member.id
                    && n.details[NEWS_DETAIL.BuildingDamage])
                ].reduce((db, n) => `${db};${n.details[NEWS_DETAIL.BuildingDamage].value}`, "");

                return (
                  <div className="col-sm-3 person-col">
                    <div
                      className={`person no-hover ${systemClass.MatchHeight}`}
                      style={{
                        minHeight: "50px",
                        marginTop: "0",
                        marginBottom: "0",
                        textAlign: "initial"
                      }}
                    >
                      <NewsPersonSummary
                        // banner={positionNews}
                        damagedBuildings={damagedBuildings}
                        ally={false}
                      />
                    </div>
                  </div>)
              })}
            </div>
          </div>
        </div>
      </>}
    </>
  )
}

export default NewsContent;
